import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resources from "./translations";

type languages = keyof typeof resources;

export const supportedLngs = Object.keys(resources) as languages[];

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  supportedLngs,
  load: "currentOnly",
  fallbackNS: "translation",
  returnNull: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
